import vSelect from 'vue-select';
import draggable from 'vuedraggable';

Vue.component('v-select', vSelect);

Vue.component('introfer-menu', {
    props: ['groups'],

    components: {
        draggable,
    },

    data () {
        return {
            myAccount: [],
            management: [],

            loading: false,

            createForm: $.extend(true, new Form({
                data: {
                    name: '',
                    path: '',
                    active: 'Yes',
                    heading: '',
                    permissions: ''
                }
            }), {}),

            dragData: {}
        };
    },

    mounted () {
        this.getMenu();
    },

    methods: {
        getMenu () {
            this.loading = true;

            axios.get('/api/menu').then((response) => {
                this.items = [];

                for (let item of response.data) {
                    const itemPermissions = JSON.parse(item.permissions);
                    const permissions = this.groups.filter(g => itemPermissions.indexOf(g.id) !== -1);

                    let data = {
                        id: item.id,
                        name: item.name,
                        active: item.active == 1 ? 'Yes' : 'No',
                        heading: item.heading,
                        permissions: permissions
                    };

                    if (item.heading === 'My Account') {
                        this.myAccount.push(data);
                    } else {
                        this.management.push(data);
                    }
                }

                this.loading = false;
            });
        },

        store () {
            Http.post('/api/menu/create', this.createForm).then((response) => {
                // Reload the main list
                this.getMenu();
            });
        },

        save (type) {
            if (type === 'My Account') {
                axios.post('/api/menu/save', this.myAccount);
            } else {
                axios.post('/api/menu/save', this.management);
            }
        }
    }
});